import { Injectable, Output, EventEmitter, ViewChild } from '@angular/core';
import { SharedFilterData } from '../models/shared-filter-data';

/** @deprecated this thing is useless REMOVE */
@Injectable({
  providedIn: 'root',
})
export class SharedFilterDataService {
  areFiltersLoaded: boolean = true; // Leave it as true for the moment, while we look as to what changes we can do

  /** Reference to the dropdown filter used to display the status */

  constructor() {}

  data: SharedFilterData = {
    minStartDate: null,
    selectedStartDate: null,
    selectedEndDate: null,
    'open-closed': 'open',
    cpoQuery: '',
    serialNumberQuery: '',
    trackingNumberQuery: '',
    selectedStatuses: [],
    selectedTypes: [],
    selectedSites: [],
  };

  storeDates(minStartDate?: Date, maxEndDate?: Date, selectedStartDate?: Date, selectedEndDate?: Date) {
    this.data.minStartDate = minStartDate ?? this.data.minStartDate;
    this.data.selectedStartDate = selectedStartDate ?? this.data.selectedStartDate;
    this.data.selectedEndDate = selectedEndDate ?? this.data.selectedEndDate;
  }

  storeOpenClosedFilter(openClosed: 'both' | 'open' | 'closed') {
    this.data['open-closed'] = openClosed;
  }

  get getDates(): SharedFilterData {
    return this.data;
  }

  notifyFiltersAreLoaded() {
    // When are filters notified they're loaded?
    this.areFiltersLoaded = true; // In support module never... Must be due to the caching mechanism
    // No longer makes sense, as filters load independently... Why do we need to wait to all filters to be loaded
  }

  notifyFiltersAreNotLoaded() {
    this.areFiltersLoaded = false;
  }
}
